module.exports = __webpack_public_path__ + "img/69.a1eb2a3a.svg";